/* eslint-disable */
import React, { useState, useContext, useEffect } from "react";
import { Button, Form, Badge } from 'react-bootstrap';
import { Link, useNavigate, useLocation, useParams  } from "react-router-dom";
import { RESALE_BRANDS_URL } from "../../Shared/constant";
import EmptySpaceFieldValid from "../../Common/EmptySpaceFieldValid";
import CheckValid from "../../Common/CheckValid";
import { useSelector, useDispatch } from "react-redux";
import { WebSocketContext } from "../../../App";
import wsSend_request from "../../../Api/ws/ws_request";
import CommonToggle from "../../Common/CommonToggle";

const AddResaleBrands = () => {
    const Navigate = useNavigate();
    const Dispatch = useDispatch();
    const LocationRoute = useLocation()?.pathname?.split("/")[1];
    const { websocket } = useContext(WebSocketContext);
    const [ ApplicationState, setApplicationState ] = useState({
        BrandName: "",
        Percentage: "",
        Status: true,
    });
    const { roomId } = useParams();
    const { ClearFormSet, ResellBrandList, device_id } = useSelector((state) => state.adminReducers);
    const CurrentData_ = ResellBrandList?.list?.filter((elm) => elm?.id === roomId)[0];
    const exceptThisCostSymbols = ["e", "E", "+", "-"];

    // error state
    const [ errorBrandName, setErrorBrandName ] = useState("");
    const [ errorPercentage, setErrorPercentage ] = useState("");

    useEffect(() => {
        if(LocationRoute === "edit-resale-brand") {
            setApplicationState({
                ...ApplicationState,
                BrandName: CurrentData_?.brand_name,
                Percentage: CurrentData_?.resale_percentage,
                Status: CurrentData_?.is_active,
            });
        };
    }, [ CurrentData_ ]);

    // create and edit brand
    const CreateBrand = () => {
        if(ApplicationState?.BrandName !== "" && ApplicationState?.Percentage !== "") {
            if(LocationRoute === "edit-resale-brand") {
                let param = { 
                    "transmit": "broadcast", 
                    "url": "refurbished_brand_edit",
                    "request" : { 
                        "refurbished_brand_id": CurrentData_?.id,
                        "brand_name" : ApplicationState?.BrandName,
                        "resale_percentage" : ApplicationState?.Percentage,
                        "is_active" : ApplicationState?.Status,
                    },
                    "DeviceId" : device_id
                };
                wsSend_request(websocket, param);
            } else {
                let param = { 
                    "transmit": "broadcast", 
                    "url": "refurbished_brand_add",
                    "request" : { 
                        "brand_name" : ApplicationState?.BrandName,
                        "resale_percentage" : ApplicationState?.Percentage,
                        "is_active" : ApplicationState?.Status,
                    },
                    "DeviceId" : device_id
                };
                wsSend_request(websocket, param);
            }
        } else {
            CheckValid(ApplicationState?.BrandName, {type: 'BrandName', error: setErrorBrandName});
            CheckValid(ApplicationState?.Percentage, {type: 'Percentage', error: setErrorPercentage});
        };
    };

    useEffect(() => {
        if(ClearFormSet?.action === 200 && (ClearFormSet?.url === "refurbished_brand_add" || ClearFormSet?.url === "refurbished_brand_edit")) {
            Navigate(RESALE_BRANDS_URL);
        };
    }, [ ClearFormSet ]);

    document.addEventListener("wheel", function(event){
        if(document.activeElement.type === "number" && document.activeElement.classList.contains("inputBoxs")) {
            document.activeElement.blur();
        }
    });

    return(<section className="createApplcation_wrapper">
        <div className="MainHeader">
            <Link to={RESALE_BRANDS_URL} className="btn btn-link backbtn"><i className="bi bi-arrow-left-short"></i> Back</Link>
        </div>
        <div className="tabsWrappers">
            <div className="formloginset">
                <div className="row">
                    <div className="col-md-6">
                        <Form.Group className="mb-3" >
                            <Form.Label>Brand Name<span className="mendatory_star">*</span></Form.Label>
                            <Form.Control 
                                type="text" 
                                value={ApplicationState?.BrandName} 
                                onChange={(e) => setApplicationState({...ApplicationState, BrandName: e.target.value})}
                                onKeyUp={(e) => CheckValid(e.target.value, {type: 'BrandName', error: setErrorBrandName})}
                                onKeyDown={(e) => EmptySpaceFieldValid(e)}
                                placeholder="Enter Brand Name" 
                            />
                            {errorBrandName !== "" && (<span className="error_medotory">{errorBrandName}</span>)}
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <Form.Group className="mb-3" >
                            <Form.Label>Max Percentage<span className="mendatory_star">*</span></Form.Label>
                            <Form.Control 
                                type="number" 
                                className="inputBoxs"
                                value={ApplicationState?.Percentage} 
                                onChange={(e) => setApplicationState({...ApplicationState, Percentage: e?.target?.value.replace(/^0/, "")})}
                                onKeyUp={(e) => CheckValid(e.target.value, {type: 'Percentage', error: setErrorPercentage})}
                                onKeyDown={(e) => {
                                    EmptySpaceFieldValid(e)
                                    exceptThisCostSymbols.includes(e.key) && e.preventDefault()
                                }}
                                placeholder="Enter Max Percentage" 
                                min="0"
                            />
                            {errorPercentage !== "" && (<span className="error_medotory">{errorPercentage}</span>)}
                        </Form.Group>
                    </div>
                    <div className="col-md-6">
                        <CommonToggle 
                            isBadgeAllow={true}
                            badgeTitle={"active_inactive"}
                            valueToggle={ApplicationState?.Status}
                            setValueToggle={() => setApplicationState({...ApplicationState, Status: !ApplicationState?.Status})}
                            name={"Status"}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-12">
                        <Button className="formbtn widthfullbtn" onClick={() => CreateBrand()} variant="primary" >
                            {LocationRoute === "edit-resale-brand" ? "Update" : "Add"}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    </section>)
}

export default AddResaleBrands;